import React from "react";
import DataTable from "../../DataTable/index";
import {Typography} from "@mui/material";
import {useSelector} from "react-redux";

export default function TeamRankingTable(props) {
    const userRole = useSelector((state) => state.userDetailsReducer?.role);

    const getPoints = (points) => {
        return parseFloat(points.toFixed(2));
    }

    const columns =
        userRole === "admin" || userRole === "super"
            ? [
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            Rank
                        </Typography>
                    ),
                    selector: (row) => row.rank,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {row.rank}
                            </p>
                        );
                    },
                },
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            Name
                        </Typography>
                    ),
                    selector: (row) => row.name,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {row.name}
                            </p>
                        );
                    },
                },
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            No. of Players
                        </Typography>
                    ),
                    selector: (row) => row.noOfPlayer,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {row.players.length}
                            </p>
                        );
                    },
                },
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            Points
                        </Typography>
                    ),
                    selector: (row) => row.points,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {getPoints(row.points)}
                            </p>
                        );
                    },
                },
            ]
            : [
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            Rank
                        </Typography>
                    ),
                    selector: (row) => row.rank,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {row.rank}
                            </p>
                        );
                    },
                },
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            Name
                        </Typography>
                    ),
                    selector: (row) => row.name,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {row.name}
                            </p>
                        );
                    },
                },
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            No. of Players
                        </Typography>
                    ),
                    selector: (row) => row.noOfPlayer,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {row.noOfPlayer}
                            </p>
                        );
                    },
                },
                {
                    name: (
                        <Typography variant="subtitle2" fontWeight={700}>
                            Points
                        </Typography>
                    ),
                    selector: (row) => row.points,
                    sortable: true,
                    cell: (row, index, column, id) => {
                        return (
                            <p data-tag="allowRowEvents" style={{marginTop: 15}}>
                                {getPoints(row.points)}
                            </p>
                        );
                    },
                },
            ];

    const conditionalRowStyles = {
        headRow: {
            style: {
                borderStyle: "solid",
                borderWidth: "1px",
                borderColor: "rgba(0,0,0,0.6)",
                borderRadius: "5px",
            },
        },
        cells: {
            style: {
                "&:hover": {
                    // cursor: "pointer !important",
                },
            },
        },
    };

    return (
        <DataTable
            columns={columns}
            data={props?.data}
            selectableRows={false}
            persistTableHead
            pagination={false}
            progressPending={props?.progressPending}
            progressComponent={props?.progressComponent}
            customStyles={conditionalRowStyles}
            direction="vertical"
            striped={true}
            onChangeRowsPerPage={props?.onChangeRowsPerPage}
            clearRow={props?.clearRow}
            onSelectedRowsChange={props?.onSelectedRowsChange}
            onRowClicked={props?.onRowClicked}
        />
    );
}
